<template>
	<div class="my">
      <img class="my_img" src="static/images/per_01.png" alt="">
		  <div class="cont">
        <img class="portrait" :src="currentImg" alt="" @click="changeImg">
        <div class="name">{{name}}</div>
        <div class="in">{{biaoqian}}</div>
        <div class="grxx" @click="myMsg">个人信息</div>
        <div class="wdsc" @click="myCollect">我的收藏</div>
        <div class="xgmm" @click="changePW" v-if="xgmmShow">修改密码</div>
        <div class="lo" @click="lo()" v-show="isLogin">退出登录</div>
        <div class="lo" @click="los()" v-show="!isLogin">登  &nbsp; &nbsp;&nbsp;&nbsp;录</div>
        <input type="file" id="fileInput" @change="tirggerFile($event)" v-if="clearShow" style="display: none">
      </div>
	</div>
</template>

<script>
  import { Indicator } from 'mint-ui';
  import { Toast } from 'mint-ui';
  import {api} from '../global/api';
  import { MessageBox } from 'mint-ui';
	export default {
		data () {
		    return {
          MessageBox:{},
          clearShow:true,
          deviceArray:[],
          name:localStorage['nickName'],
          biaoqian:"",
          currentImg:localStorage['headimgurl'],
          isLogin:false,
          xgmmShow:true
		    }
		},
    mounted(){
		  this.init()
      localStorage['userid']==""?this.isLogin=false:this.isLogin=true;
    },
    created(){
          if(localStorage['loginType']=="1"){
            this.xgmmShow=false
          }else{
            this.xgmmShow=true
          }
    },
		methods:{
        lo(){
          let that=this;
          MessageBox.confirm('', {
            message: '是否现在就退出？',
            title: '',
            confirmButtonText: '退出',
            cancelButtonText: '稍后'
          }).then(action => {
            if (action == 'confirm') {     //确认的回调
              console.log(123)
              that.$http.get(api.loginOut).then(response  => {
                if(response.data.success==1){
                  localStorage.clear();
                  //localStorage['userid']="";
                  that.$router.push({ path: 'my/login'});
                }else{

                }
              })
            }
          }).catch(err => {
            if (err == 'cancel') {     //取消的回调
              console.log(2);
            }
          });

        },
      los(){
        this.$router.push({ path: 'my/login'});
      },
      changeImg(){
          if(localStorage['userid']==""){
            this.$router.push({ path: 'my/login'});
            return false
          }
        document.getElementById('fileInput').click();

      },
      init(){
        let that=this;
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        let params={"userID":localStorage['userid'],"token":localStorage['token']};
        this.$http.get(api.userInfo, {params:params}).then(response => {
          if(response.data.success==1){
            Indicator.close();
            that.name=response.data.data.user.nickName;
           response.data.data.user.tag==""?that.biaoqian="这个人很懒，什么都没有留下":that.biaoqian= response.data.data.user.tag;
           //that.currentImg=response.data.data.user.avatarurl!=""?response.data.data.user.avatarurl:;
           if(response.data.data.user.avatarurl!=""&&localStorage['loginType']!="1"){
             that.currentImg=response.data.data.user.avatarurl;
           }
          }/*else if(response.data.success==999){
            that.$router.push({ path: 'my/login'});
          }*/
          else{
             Indicator.close();
            that.$router.push({ path: 'my/login'});
          }
        }, response => {
          console.log("请求失败了");
        })
      },
      tirggerFile(e) {
        this.deviceArray = [];
        let that=this;
        let deviceFile = e.target.files;
        let formData = new FormData();
       /* for(let i=0;i<deviceFile.length;i++){
          formData.append('upFile', deviceFile[i]);
        }*/
        formData.append('file', deviceFile[0]);
        formData.append('userId', localStorage['userid']);
        formData.append('token', localStorage['token']);
        //formData.file= deviceFile[0];
       /// formData.userId= "75412f3f53634a2e93745fe5225a39bb";
       // formData.token= localStorage['token'];
        this.clearShow = false;
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        debugger
       // let params={formData,"userID":localStorage['userid'],"token":localStorage['token']};
        this.$http.post(api.uploadHeadImage,formData, config
        ).then((res)=>{
          if(res.data.success==1){
            that.currentImg=res.data.data;
            that.clearShow = true;
          }else if(response.data.success==999){
            this.$router.push({ path: './login'});
          }
        },()=>{
          that.clearShow = true;
        });
      },
      myMsg(){
          this.$router.push({ path: 'my/message'})
        },
      myCollect(){
          this.$router.push({ path: 'my/mine'})
        },
      changePW(){
          this.$router.push({ path: 'my/passWord'})
        },

		}
	}
</script>
<style lang="scss" scoped="">
  .my{
    height: 100%;
    width: 100%;
    background-color: rgba(241, 241, 242, 1);
    overflow-x: hidden;
  }
  .my_img{
    width: 100%;
    display: inline-block;
    position: relative;
    z-index: 10;
  }
  .cont{
    margin: -2.15rem auto 5rem;
    width: 17.25rem;
    height: 13.6rem;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    z-index: 20;
    position: relative;
    padding-top: 2.4rem;
  }
  .portrait{
    width: 5rem;
    height: 5rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -3.1rem;
    z-index: 30;
    border-radius: 50%;
  }
  .name{
    color: rgb(51,51,51);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFangSC-Medium;
  }
  .in{
    text-align: center;
    line-height: 18px;
    color: rgba(153, 153, 153, 1);
    font-size: 13px;
    font-family: PingFang-SC-Regular;
    margin-top: 4px;
  }
  .grxx{
    width: 13.75rem;
    height: 1.8rem;
    border-radius: 8px;
    margin: 1.85rem auto 0;
    background: rgb(241,241,241) url("../../static/images/grxx.svg") no-repeat 0.65rem 0.4rem;
    background-size: 0.8rem 1rem;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    padding-left: 2rem;
    line-height: 1.8rem;
  }
  .wdsc{
    width: 13.75rem;
    height: 1.8rem;
    border-radius: 8px;
    margin: 0.5rem auto 0;
    background: rgb(241,241,241) url("../../static/images/wdsc.svg") no-repeat 0.65rem 0.4rem;
    background-size: 0.8rem 1rem;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    padding-left: 2rem;
    line-height: 1.8rem;
  }
  .xgmm{
    width: 13.75rem;
    height: 1.8rem;
    border-radius: 8px;
    margin: 0.5rem auto 0;
    background: rgb(241,241,241) url("../../static/images/xgmm.svg") no-repeat 0.65rem 0.4rem;
    background-size: 0.8rem 1rem;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    padding-left: 2rem;
    line-height: 1.8rem;
  }
  .lo{
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/my.vue